import type { RatedAnswerOrder } from '../../../types/RatedAnswerOrder';
import { get } from '../request';

export type ReviewRatedAnswerOrderDto = {
    questionId: number;
    reviewee: RatedAnswerOrder | null;
    reviewer: RatedAnswerOrder | null;
};

getForCycle.operation = 'READ';
export function getForCycle(cycleId: string, questionIds: number[]) {
    return get<ReviewRatedAnswerOrderDto[]>(`/api/v2/review-cycles/${cycleId}/answer-orders`, {
        getData: { questionIds: questionIds.join(',') },
    }).then(dtos => dtos.map(dto => ({ ...dto, id: `${cycleId}-${dto.questionId}` })));
}
